// extracted by mini-css-extract-plugin
var _1 = "AcceptAndConfirmListAppStyle-module__form___kbv9g";
var _2 = "AcceptAndConfirmListAppStyle-module__form-row___aLEsb";
var _3 = "AcceptAndConfirmListAppStyle-module__form-row-content___JoQrF";
var _4 = "AcceptAndConfirmListAppStyle-module__form-row-header___ZOAOe";
var _5 = "AcceptAndConfirmListAppStyle-module__form-submit-wrapper___ee_JM";
var _6 = "AcceptAndConfirmListAppStyle-module__form-row___aLEsb";
var _7 = "AcceptAndConfirmListAppStyle-module__form-row-content___JoQrF";
var _8 = "AcceptAndConfirmListAppStyle-module__form-row-header___ZOAOe";
var _9 = "AcceptAndConfirmListAppStyle-module__form-submit-wrapper___ee_JM";
var _a = "AcceptAndConfirmListAppStyle-module__termsWrapper___rgSwf";
export { _1 as "form", _2 as "form-row", _3 as "form-row-content", _4 as "form-row-header", _5 as "form-submit-wrapper", _6 as "formRow", _7 as "formRowContent", _8 as "formRowHeader", _9 as "formSubmitWrapper", _a as "termsWrapper" }
